import { render, staticRenderFns } from "./packageDetail.vue?vue&type=template&id=2f3c0573&scoped=true"
import script from "./packageDetail.vue?vue&type=script&lang=js"
export * from "./packageDetail.vue?vue&type=script&lang=js"
import style0 from "./packageDetail.vue?vue&type=style&index=0&id=2f3c0573&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3c0573",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f3c0573')) {
      api.createRecord('2f3c0573', component.options)
    } else {
      api.reload('2f3c0573', component.options)
    }
    module.hot.accept("./packageDetail.vue?vue&type=template&id=2f3c0573&scoped=true", function () {
      api.rerender('2f3c0573', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportManagement/packingOperationRecord/component/packageDetail.vue"
export default component.exports